import styled from 'styled-components';
import { FadeIn, TooltipStyle } from '../Tooltip/Tooltip';

const BookmarkContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: ${(props) => (props.placement === 'left' ? 'row' : 'column')};
  max-width: 120px;
  position: relative;

  ${TooltipStyle} {
    position: ${(props) =>
      props.placement === 'top' ? 'absolute' : 'relative'};
    top: ${(props) => (props.placement === 'top' ? '-36px' : '0')};
    left: ${(props) => (props.placement === 'top' ? '-27px' : '0')};
  }

  &:hover ${TooltipStyle} {
    animation: ${FadeIn} 300ms;
    opacity: 1;
  }
  svg {
    height: ${(props) => props.bookmarkSVGHeight}px;
    width: ${(props) => props.bookmarkSVGWidth}px;
  }
`;

export default BookmarkContainer;
